module.exports = __webpack_public_path__ + "img/edit_24.0fb155e6.svg";